import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
//import VueQuillEditor from 'vue-quill-editor'

// 导入富文本编辑器样式
//import 'quill/dist/quill.core.css'
//import 'quill/dist/quill.snow.css'
//import 'quill/dist/quill.bubble.css'
// 引入拦截器配置文件
import axiosInstance from './api/axios'
// 导入全局样式
import './assets/global.css'

// 引入element-plus
const app = createApp(App)
app.use(router)
app.use(ElementPlus)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
// 配置全局axios
app.config.globalProperties.$http = axiosInstance
//app.use(VueQuillEditor, /* { default global options } */)
app.mount('#app')
